import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDeviceSignalTagDocument } from './delete.generated';

export const useDeleteDeviceSignalTag = (
  options: ApiOptions<typeof DeleteDeviceSignalTagDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(DeleteDeviceSignalTagDocument, {
    ...useNotifications(DeleteDeviceSignalTagDocument, {
      failure: t('api.device_signal_tags.delete_error'),
      success: t('api.device_signal_tags.delete_success'),
    }),
    ...options,
  });
};
